import {useUserState} from "../store/user-store";

const useIsSsoLogin = (): boolean => {
    return !!useUserState((state) => state.currentUser?.ssoSessionUsed)
};

export default useIsSsoLogin;
